import styled from 'styled-components';

export const Wrapper = styled.div`
  .files {
    .file {
      color: #00122d;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      border-bottom: 1px solid #e1e1e1;
      padding: 10px 0;

      &:last-child {
        border-bottom: none;
      }
    }
  }
`;
